import { useState, useContext, useEffect } from "react";
import styles from "./styles.module.css";
import { BlocksValue } from "../../../contexts/blocks";
import { db } from "../../../firebase";
import { useParams } from "react-router-dom";
import PropInput from "./propinput";

export default function Editor({ style, setStyle }) {
  const blocks = useContext(BlocksValue);
  const [_block, setBlock] = useState(null);
  const { appId } = useParams();
  const [name, setName] = useState("");

  useEffect(() => {
    setName(style.name);
    const block = blocks.find((x) => x.name === style.component);
    setBlock(block);
  }, [blocks, style]);

  const handleSave = (v) => {
    setStyle(v);
    db.collection("apps")
      .doc(appId)
      .collection("styles")
      .doc(style.id)
      .set(v, { merge: true });
  };

  const handleChangeName = () => {
    const newStyle = { ...style };
    newStyle.name = name;
    handleSave(newStyle);
  };

  const handleDelete = () => {
    setBlock(null);
    setStyle({});
    db.collection("apps")
      .doc(appId)
      .collection("styles")
      .doc(style.id)
      .delete();
  };

  if (!_block) {
    return null;
  }
  return (
    <div className={styles.editor}>
      <input
        onBlur={handleChangeName}
        className={styles.nameInput}
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      {_block.props
        .filter((x) => !!x.editorParams.styleName)
        .map((p, index) => {
          return (
            <PropInput
              key={p.name}
              prop={p}
              style={style}
              index={index}
              onChange={handleSave}
            />
          );
        })}
      <div className={styles.propInput}>
        <div className={styles.propTitle}>Danger Zone</div>
        <button onClick={handleDelete} className={styles.delete}>
          Delete Style
        </button>
      </div>
    </div>
  );
}
